const getters = {
  scEmployees: state => state.sc_employees,
  scEmployee: state => state.sc_employee,
  scEmployeeFilters: state => state.sc_employee_filters,
}

export default getters;
